import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "carousel-inner-container mt-6 mr-6 pb-6"
}
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "center-aligned" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 meb-text-carousel-white"
}
const _hoisted_6 = {
  key: 1,
  class: "meb-text-carousel-yellow"
}
const _hoisted_7 = {
  key: 1,
  class: "carousel-inner-container mt-6 mr-6 pb-6"
}
const _hoisted_8 = { class: "center-aligned pt-6" }
const _hoisted_9 = { class: "meb-txt-gradient" }




export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSectionCarouselComponent',
  props: {
  image: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (props.image!='')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("figure", _hoisted_2, [
          _createElementVNode("img", {
            src: require(`@/assets/images/${props.image}`)
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (props.image.startsWith('carousel-bk'))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('ITEM_'+ props.name )), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('ITEM_'+ props.name )), 1))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('ITEM_'+ props.name )), 1)
        ])
      ]))
}
}

})